import Grid from '@mui/material/Grid2';
import { styled } from '@mui/system';
import Map from 'Components/Maps';
import { actions } from 'ducks/sites';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Marker from './Marker';
import Search from './Search';

const siteStateToMarkers = (ids, models) => {
    return ids.reduce((acc, id) => {
        if (models[id].status !== 'disabled') {
            acc.push({
                lat: models[id].latitude,
                lng: models[id].longitude,
                Component: Marker,
                site: models[id]
            });
        }

        return acc;
    }, []);
};

const MapContainer = styled(Grid)({
    height: 'calc(100vh - 64px)',
    width: '100%'
});

const Component = props => {
    const {
        defaultCenter = { lat: 38.7390071088303, lng: -9.10513977732148 },
        defaultZoom = 6
    } = props;

    const ids = useSelector(state => state.sites.ids);
    const models = useSelector(state => state.sites.models);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(actions.startPoolingSites());
        return () => dispatch(actions.stopPoolingSites());
    }, [dispatch]);

    const markers = useMemo(() => siteStateToMarkers(ids, models), [ids, models]);

    return (
        <MapContainer>
            <Map
                defaultCenter={defaultCenter}
                defaultZoom={defaultZoom}
                markers={markers}
            >
                <Search/>
            </Map>
        </MapContainer>
    );
};

export default Component;
